import { Film } from "lucide-react";

export const Footer = () => (
  <footer className="border-t border-[#D4AF37]/10 mt-24" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-6 py-12 flex flex-col md:flex-row justify-between gap-6">
      <div>
        <div className="flex items-center gap-2 mb-3">
          <Film className="w-5 h-5 text-[#D4AF37]" />
          <span className="font-display text-xl text-white tracking-wide">PROPMOTION</span>
        </div>
        <p className="text-sm text-slate-500 max-w-sm">
          Autonomous AI-powered luxury property films. A product of AIH LLC.
        </p>
      </div>
      <div className="text-sm text-slate-500">
        <p className="font-mono text-xs tracking-[0.25em] uppercase text-[#D4AF37]/80 mb-3">Delivery under 24 hours</p>
        <p>© {new Date().getFullYear()} AIH LLC. All rights reserved.</p>
      </div>
    </div>
  </footer>
);
